import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import SearchIconVector from "../../Images/SearchVector.png";
import SettingVector from "../../Images/SettingVector.png";
import NotificationVector from "../../Images/NotificationVector.png";
import { init } from "../../config/provider.js";
import { CircularProgress } from "@mui/material";
import { userInfoContext } from "../../Context/userInfoContext.js";
import { userProviderContext } from "../../Context/userProviderContext.js";

const Root = styled.div``;
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
  /* margin-left:15px; */
  padding: 25px 20px;
  width: 100%;
`;

const SearchWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 80%;
`;
const SearchInput = styled.input`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px 50px 15px 22px;
  gap: 21px;
  outline: none;
  border: none;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.1);
  width: 20%;
  font-size: 15px;
  color: white;
  ::placeholder {
    color: white;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
  }
`;
const SearchIcon = styled.img`
  position: absolute;
  display: flex;
  align-items: center;
  left: 17%;
  cursor: pointer;
`;
const SettingNotificationWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px;
  /* width: 20%; */
`;
const SettingWrapper = styled.div`
  padding: 0 15px;
`;
const NotificationWrapper = styled.div`
  padding: 0 15px;
`;
const Setting = styled.img`
  cursor: pointer;
`;
const Notification = styled.img`
  cursor: pointer;
`;

const AddressTextWrapper = styled.div`
  /* margin:  0 20px; */
  display: flex;
  align-items: center;
  text-align: center;
`;
const AddressText = styled.div`
  font-size: 20px;
  font-weight: 800;
  text-align: LEFT;
  color: #fff;
  line-height: 50px;
  margin-right: 20px;
`;

const Button = styled.button`
  width: 100%;
  padding: 15px 20px;
  border-radius: 10px;
  border: none;
  font-size: 16px;
  font-weight: 700;
  margin: 10px 12px;
  cursor: pointer;
  background-color: rgb(146 95 146);
  color: white;
`;

const SearchTopbar = ({ allContractDetails, setAllContractDetails }) => {
  const [address, setAddress] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const {setUserToken}=useContext(userInfoContext)
  const {setUserProvider}=useContext(userProviderContext)
  useEffect(() => {
    if (allContractDetails?.address) {
      const address = allContractDetails.address;
      setAddress(address);
    } else {
      setAddress("");
    }
  }, [allContractDetails]);
  useEffect(() => {
    // if (localStorage.getItem("Web3Auth-cachedAdapter")) {
    setIsLoading(true);
    init()
      .then((response) => {
        console.log(response);
        setAllContractDetails(response);
        setUserToken(response?.idToken?.idToken);
        setUserProvider(response.loginType)
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
    // }
  }, []);

  const connectWallet = async () => {
    setIsLoading(true);
    try {
      const data = await init();
      console.log(data, "----------data after login-----------");
      setAllContractDetails(data);
      
      setIsLoading(false);
    } catch (error) {
      console.log("Error:", error);
      setIsLoading(false);
    }
    // init()
    //   .then((data) => {
    //     console.log(data);
    //     setAllContractDetails(data);
    //   })
    //   .catch((err) => {
    //     console.log("err", err);
    //   });
  };
  const logoutWallet = async () => {
    try {
      await allContractDetails.logout();
      setAllContractDetails({});
    } catch (error) {
      console.log("Error:", error);
    }
    // allContractDetails
    //   .logout()
    //   .then((data) => {
    //     console.log("logout data", data);
    //     setAllContractDetails({});
    //   })
    //   .catch((err) => {
    //     console.log("err", err);
    //   });
  };

  return (
    <Root>
      <Container>
        <SearchWrapper>
          <SearchInput placeholder="search" />
          <SearchIcon src={SearchIconVector} />
        </SearchWrapper>

        <SettingNotificationWrapper>
          <AddressTextWrapper>
            {/* <AddressText> */}
            {isLoading ? (
              <CircularProgress
                color="inherit"
                style={{ width: "26px", height: "26px" }}
              />
            ) : (
              <React.Fragment>
                {address ? (
                  <>
                    {/* <span >{address.slice(0, 6)}...{address.slice(address.length - 4, address.length)}</span> */}
                    <span>{address}</span>
                    <Button
                      styled={{ margin: "0 10px" }}
                      onClick={logoutWallet}
                    >
                      {" "}
                      Logout{" "}
                    </Button>
                  </>
                ) : (
                  <Button onClick={connectWallet}> Connect Wallet </Button>
                )}
              </React.Fragment>
            )}
            {/* <Button > Connect Wallet </Button> */}
            {/* </AddressText> */}
          </AddressTextWrapper>
          <SettingWrapper>
            <Setting src={SettingVector} />
          </SettingWrapper>
          <NotificationWrapper>
            <Notification src={NotificationVector} />
          </NotificationWrapper>
        </SettingNotificationWrapper>
      </Container>
    </Root>
  );
};

export default SearchTopbar;
